import { createContext } from 'react';

const CommonContextV2 = createContext({
    query: {},
    appId: null,
    appName: null,
    productInfo: null
});

export default CommonContextV2;
